import { confirmationDialog } from '@/components'
import api from '@/services/api'
import handleErrors from '@/services/handleErrors'

export async function batchInvitations() {
  const confirm = await confirmationDialog.open(
    'Confirmar',
    'Enviar convites para todas as empresas ?'
  )

  if (confirm) {
    try {
      await api.post('/admin/batch_invitations')

      return true
    } catch (error) {
      handleErrors(error, 'Falha ao enviar os convites')

      return false
    } finally {
      confirmationDialog.close()
    }
  }

  confirmationDialog.close()

  return false
}

export async function getPendingInvitationsCount() {
  try {
    const response = await api.get('/admin/pending_invitations_count')

    return response.data.count
  } catch (error) {
    return 0
  }
}

export async function getPendingWebCompaniesCount() {
  try {
    const response = await api.get('/admin/pending_web_companies_count')

    return response.data.count
  } catch (error) {
    return 0
  }
}

export async function updateWebCompanies() {
  try {
    await api.post('/admin/update_web_companies')

    return true

    // toast.success('Cadastro atualizado')
  } catch (error) {
    handleErrors(error)

    return false
  }
}
